import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DoExchange, GetExchangeData, DeleteExchange } from '../../common/actions/moreAction';
import { convertDepositString, convertStyle, dateFormation, isEmpty, isMobilePage, moneyValues, no_comma } from '../../common/cores';
import Pagenation from '../common/Pagenation';

const PointContent = (props) => {

    const [money, setMoney] = useState(0);
    const [showHis, setShowHis] = useState(false);
    const lists = props.pointexchange.data;
    const { page, user } = props;
    let ids = [];
    // console.log(page.curPage );

    const getLists = (page) => {
        props.GetExchangeData(Number(page));
    }

    const reset = () => {
        setMoney(0);
    }


    const onChange = (e) => {
        const { value } = e.target; // 우선 e.target 에서 name 과 value 를 추출
        // console.log(isNaN(Number(value)), value);
        if (!isNaN(Number(no_comma(value))))
            setMoney(Number(no_comma(value)));
        else setMoney(0);
    };

    useEffect(() => {
        getLists(1);
    }, [props.user.isAuthenticated, props.page.perPage])

    const historyDelete = (value) => {
        console.log(value);
        if (value) props.DeleteExchange({
            ids,
            all: true,
            type: 'withdraw'
        })
        else props.DeleteExchange({
            ids,
            all: false,
            type: 'withdraw'
        })
    }

    const showHisotry = () => {
        setShowHis(!showHis);
    }

    return (
        <div data-v-394b74b4="" className="scrollable-auto column" style={{ width: "100%" }}>
            <div className="contents_box">
                <div className="con_box00">
                    <div className="write_wrap">
                        <div className="write1"><span className="info_title2">전환 포인트 입력</span></div>
                        <div className="write2">현재 포인트는 보유금액으로 이전됩니다.<br />최소 전환 가능 포인트는 1,000포인트 이상부터 신청이 가능합니다.</div>
                        <div className="write3">
                            <table width="100%" border="0" cellSpacing="0" cellPadding="0" className="write_title_top">
                                <tbody>
                                    <tr>
                                        <td className="write_title">사용가능 포인트</td>
                                        <td className="write_basic"><span className="font14">{!isEmpty(user.data.balance) && Number(user.data.balance.rolling).toLocaleString()}</span>원</td>
                                    </tr>
                                    <tr>
                                        <td className="write_title">전환 포인트</td>
                                        <td className="write_basic">
                                            <input className="input1" type="text"
                                                placeholder="전환하실 포인트를 입력해주세요"
                                                inputMode="numeric"
                                                onChange={onChange}
                                                value={Number(money).toLocaleString()} />
                                            {
                                                isMobilePage() ?
                                                    <table width="100%" border="0" align="center" cellSpacing="2" cellPadding="0">
                                                        <tbody>
                                                            <tr>
                                                                <td width="10%" align="center"><a onClick={() => setMoney(money + 10000)}><span className="m_btn1_2 m-r-2">1만원</span></a></td>
                                                                <td width="10%" align="center"><a onClick={() => setMoney(money + 30000)}><span className="m_btn1_2">3만원</span></a></td>
                                                                <td width="10%" align="center"><a onClick={() => setMoney(money + 50000)}><span className="m_btn1_2">5만원</span></a></td>
                                                            </tr>
                                                            <tr>
                                                                <td width="10%" align="center"><a onClick={() => setMoney(money + 100000)}><span className="m_btn1_2">10만원</span></a></td>
                                                                <td width="10%" align="center"><a onClick={() => setMoney(money + 500000)}><span className="m_btn1_2">50만원</span></a></td>
                                                                <td width="10%" align="center"><a onClick={() => setMoney(money + 1000000)}><span className="m_btn1_2">100만원</span></a></td>
                                                            </tr>
                                                            <tr>
                                                                <td width="10%" align="center"><a onClick={() => setMoney(money + 3000000)}><span className="m_btn1_2">300만원</span></a></td>
                                                                <td width="10%" align="center"><a onClick={() => setMoney(money + 5000000)}><span className="m_btn1_2">500만원</span></a></td>
                                                                <td width="10%" align="center"><a onClick={reset}><span className="m_btn1_1">정정</span></a></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    :
                                                    <Fragment>
                                                        <br />
                                                        <br />
                                                        <a onClick={() => setMoney(money + 10000)}><span className="btn1_2 m-r-2">1만원</span></a>
                                                        <a onClick={() => setMoney(money + 30000)}><span className="btn1_2 m-r-2">3만원</span></a>
                                                        <a onClick={() => setMoney(money + 50000)}><span className="btn1_2 m-r-2">5만원</span></a>
                                                        <a onClick={() => setMoney(money + 100000)}><span className="btn1_2 m-r-2">10만원</span></a>
                                                        <a onClick={() => setMoney(money + 500000)}><span className="btn1_2 m-r-2">50만원</span></a>
                                                        <a onClick={() => setMoney(money + 1000000)}><span className="btn1_2 m-r-2">100만원</span></a>
                                                        <a onClick={() => setMoney(money + 5000000)}><span className="btn1_2 m-r-2">500만원</span></a>
                                                        <a onClick={() => setMoney(money + 10000000)}><span className="btn1_2 m-r-2">1000만원</span></a>
                                                        <a onClick={reset}><span className="btn1_1 m-r-2">정정</span></a>
                                                    </Fragment>
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="con_box30">
                    <div className="btn_wrap_center">
                        <ul>
                            <li><a ><span className="btn3_1 m-r-2" onClick={() => props.DoExchange(money)}>포인트전환</span></a></li>
                            {!isMobilePage() && <li><a ><span className="btn3_2" onClick={reset}>취소</span></a></li>}
                        </ul>
                    </div>
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = state => ({
    user: state.user,
    pointexchange: state.more.pointexchange,
    page: state.page
})

export default connect(mapStateToProps, { GetExchangeData, DoExchange, DeleteExchange })(PointContent);


// WEBPACK FOOTER //
// ./src/components/account/PointContent.js